/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type SimilarRecentlySoldItemsPriceRange = "BETWEEN_HIGH_AVG_AND_MAX" | "BETWEEN_LOW_AVG_AND_MEDIAN" | "BETWEEN_MEDIAN_AND_HIGH_AVG" | "BETWEEN_MIN_AND_LOW_AVG" | "MEDIAN" | "OTHER" | "OUT_OF_RANGE_HIGH" | "OUT_OF_RANGE_LOW" | "%future added value";
export type PdpRespRecentSales_item = {
    readonly similarRecentlySoldItemsPrices: {
        readonly priceRange: SimilarRecentlySoldItemsPriceRange | null;
    } | null;
    readonly displayPrice: ReadonlyArray<{
        readonly convertedAmountList: ReadonlyArray<{
            readonly amount: number | null;
            readonly currency: Currency | null;
        } | null> | null;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedRecentSales_item">;
    readonly " $refType": "PdpRespRecentSales_item";
};
export type PdpRespRecentSales_item$data = PdpRespRecentSales_item;
export type PdpRespRecentSales_item$key = {
    readonly " $data"?: PdpRespRecentSales_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespRecentSales_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespRecentSales_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SimilarRecentlySoldItemsPrices",
      "kind": "LinkedField",
      "name": "similarRecentlySoldItemsPrices",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "priceRange",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userId"
        },
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        }
      ],
      "concreteType": "ItemDisplayPriceType",
      "kind": "LinkedField",
      "name": "displayPrice",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ConvertedAmountList",
          "kind": "LinkedField",
          "name": "convertedAmountList",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "amount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "currency",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedRecentSales_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '97e5e557c8c18a76d9f4bebb6fca11ca';
export default node;
